module.exports = __webpack_public_path__ + "static/media/shower.0ba2069e.svg";